module.exports = __webpack_public_path__ + "static/media/CarritoGif.a052593c.gif";